import { useAuth } from "context/AuthContext";
import { useGlobalConfig } from "context/GlobalConfigContext";
import Lottie from "lottie-react";
import ReactModal from "react-modal";
import { useNavigate } from "react-router-dom";

import partyAnimation from "assets/lottie/party.json";
import noImage from "assets/img/semImagem.jpg";

import { usePremiosRecebidos } from "./usePremiosRecebidos";
import "./styles.scss";

/**
 * Avisa o participante de cada prêmio recebido automaticamente e de cada card
 * especial entregue. Os avisos pendentes são exibidos em sequência, um por vez.
 */
export function PremioRecebidoModal() {
  const { user } = useAuth();
  const { isFeatureEnabled } = useGlobalConfig();
  const navigate = useNavigate();

  // sem o player a fila nem é consultada, então o toggle desligado não gera requisição
  const habilitado = isFeatureEnabled("premioPopupEnabled");
  const { premioAtual, restantes, avancar } = usePremiosRecebidos(
    habilitado ? user?._id : undefined
  );

  if (!user || !premioAtual) return null;

  ReactModal.setAppElement("#modal");

  // o card ainda não é o prêmio: o participante precisa ir à vitrine trocá-lo
  const ehCardEspecial = premioAtual.tipo === "card";
  // com fila pendente o botão de saída vira "ver próximo"; sozinho, apenas fecha
  const rotuloProximo = restantes > 1 ? `VER PRÓXIMO (${restantes - 1})` : null;

  function irParaResgate() {
    avancar();
    navigate("/premios");
  }

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={avancar}
      shouldCloseOnOverlayClick={false}
      contentLabel={ehCardEspecial ? "Card especial recebido" : "Prêmio recebido"}
      portalClassName="relative z-[600]"
      overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center p-4"
      contentElement={() => (
        <div id="premioRecebidoModal">
          <div className="cartao">
            <button
              type="button"
              className="btnFechar"
              aria-label={
                ehCardEspecial ? "Fechar aviso de card" : "Fechar aviso de prêmio"
              }
              onClick={avancar}
            >
              ×
            </button>

            <div className="conteudo">
              <p className="chamada">Parabéns!</p>
              <h2 tabIndex={0}>
                {ehCardEspecial
                  ? "Você recebeu um card especial"
                  : "Você recebeu um prêmio"}
              </h2>

              <div className="areaPremio">
                <div className="confete esquerda" aria-hidden="true">
                  <Lottie animationData={partyAnimation} loop={true} />
                </div>

                <div className="molduraPremio">
                  <img src={premioAtual.imagem || noImage} alt="" />
                </div>

                <div className="confete direita" aria-hidden="true">
                  <Lottie animationData={partyAnimation} loop={true} />
                </div>
              </div>

              <p className="nomePremio">{premioAtual.nome}</p>
              {premioAtual.descricao &&
                premioAtual.descricao !== premioAtual.nome && (
                  <p className="descricaoPremio">{premioAtual.descricao}</p>
                )}

              {ehCardEspecial ? (
                <>
                  <p className="instrucaoResgate">
                    Ele fica guardado na sua vitrine até você trocar pelo
                    prêmio. É só clicar em RESGATAR na aba CARDS.
                  </p>

                  <button
                    type="button"
                    className="btnContinuar"
                    onClick={irParaResgate}
                  >
                    IR PARA O RESGATE
                  </button>

                  <button
                    type="button"
                    className="btnSecundario"
                    onClick={avancar}
                  >
                    {rotuloProximo ?? "AGORA NÃO"}
                  </button>
                </>
              ) : (
                <button type="button" className="btnContinuar" onClick={avancar}>
                  {rotuloProximo ?? "FECHAR"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    />
  );
}
